import React from 'react';
import { Toaster } from 'react-hot-toast';
import Routes from './Routes';

function App() {
  return (
    <>
      <Toaster position="top-right" />
      <Routes />
    </>
  );
}

export default App;
